'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { createRef, Component } from 'react';
import withPauseAndHelpLogic from '../higherOrderComponents/withPauseAndHelpLogic';
import vidyardApiFacade from '../utils/vidyardApiFacade';

class VidyardVideoPlayer extends Component {
  constructor(props) {
    super(props);

    this.onPlayerReady = () => {
      const {
        cancelHelpTextTimeout,
        captionsOnByDefault,
        onReady
      } = this.props;
      cancelHelpTextTimeout();
      this.bindVideoEvents(this.video);

      if (captionsOnByDefault) {
        this.video.enableCaption();
      }

      if (onReady) {
        onReady();
      }
    };

    this.bindVideoEvents = video => {
      const {
        onPlay,
        onFinish,
        onPause,
        onUpdateProgress
      } = this.props;

      if (onPlay) {
        video.bind('play', onPlay);
      }

      if (onPause) {
        video.bind('pause', onPause);
      }

      if (onFinish) {
        video.bind('playerComplete', onFinish);
      }

      if (onUpdateProgress) {
        video.bind('timeupdate', seconds => {
          if (!this.state.hasMarkedProgress && seconds > 10) {
            this.setState({
              hasMarkedProgress: true
            });
            onUpdateProgress();
          }
        });
      }
    };

    this.state = {
      hasMarkedProgress: false
    };
    this.container = /*#__PURE__*/createRef();
  }

  componentDidMount() {
    this.initVideoPlayer();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.videoId !== this.props.videoId) {
      prevProps.cancelHelpTextTimeout(); // Tear down the player and set up a new one.

      this.video.destroy();
      prevProps.onChangeVideo();
      this.setState({
        hasMarkedProgress: false
      });
      this.initVideoPlayer();
    } else if (prevProps.videoPlaySpeed !== this.props.videoPlaySpeed) {
      this.video.setPlaybackSpeed(this.props.videoPlaySpeed / 100);
    }
  }

  componentWillUnmount() {
    this.video.destroy();
  }

  initVideoPlayer() {
    const {
      videoId,
      startHelpTextTimeout
    } = this.props;
    startHelpTextTimeout();
    this.video = vidyardApiFacade(Object.assign({}, this.getOptionsFromProps(), {
      container: this.container.current,
      uuid: videoId
    }));
    this.video.onReady(this.onPlayerReady);
  }

  getOptionsFromProps() {
    const {
      color,
      autoPlay,
      enableEmbed,
      enableSharing,
      videoPlaySpeed,
      preload
    } = this.props;
    const colorCode = color && color.replace('#', '');
    return {
      autoplay: autoPlay ? '1' : '0',
      color: colorCode,
      embed_button: enableSharing ? 1 : 0,
      play_button_color: colorCode,
      preload: preload || 'metadata',
      speed: videoPlaySpeed / 100,
      viral_sharing: enableEmbed ? 1 : 0
    };
  }

  render() {
    return /*#__PURE__*/_jsx("div", {
      ref: this.container
    });
  }

}

VidyardVideoPlayer.propTypes = {
  autoPlay: PropTypes.bool,
  cancelHelpTextTimeout: PropTypes.func.isRequired,
  captionsOnByDefault: PropTypes.bool,
  color: PropTypes.string,
  enableEmbed: PropTypes.bool,
  enableSharing: PropTypes.bool,
  preload: PropTypes.string,
  onFinish: PropTypes.func,
  onPause: PropTypes.func,
  onPlay: PropTypes.func,
  onReady: PropTypes.func,
  onChangeVideo: PropTypes.func,
  onUpdateProgress: PropTypes.func,
  startHelpTextTimeout: PropTypes.func.isRequired,
  videoId: PropTypes.string.isRequired,
  videoPlaySpeed: PropTypes.number
};
export default withPauseAndHelpLogic(VidyardVideoPlayer);